import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  resultContainer: {
    backgroundColor: '#f2f6f9',
    width: '100%',
    padding: 40,
    marginVertical: 40,
    borderRadius: 20,
    flexDirection: 'row',
    alignItems: 'center',
  },
  message: {
    color: '#1d5c42',
    textAlign: 'center',
    fontStyle: 'italic',
  },
  resultDestination: {
    color: '#1d5c42',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  resultMontant: {
    fontSize: 40,
    color: '#1d5c42',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  disabledSelected: {
    width: 20,
    height: 20,
    borderRadius: 20,
    borderWidth: 2,
    borderColor: 'green',
  },
});
